import { render } from "./Premium.vue?vue&type=template&id=36cc8f8e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Premium.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36cc8f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36cc8f8e', __exports__)) {
    api.reload('36cc8f8e', __exports__)
  }
  
  module.hot.accept("./Premium.vue?vue&type=template&id=36cc8f8e", () => {
    api.rerender('36cc8f8e', render)
  })

}


export default __exports__